import { BookingListInput, URlFiltersData } from '../../../types/booking'

export const BOOKING_LIST_FILTERS_DEFAULT_VALUE: BookingListInput = {
  tenantsCode: [],
  propertyCode: [],
  roomtypeId: [],
  page: 1,
  perPage: 8,
  currency: undefined,
  guestName: '',
  sourceReservationNumber: '',
  pmsNumber: '',
  roomstayInclusionDate: '',
  endDate: '',
  startDate: '',
  departureEndDate: '',
  departureStartDate: '',
  reserveEndDate: '',
  reserveStartDate: '',
  masterCRSNumber: '',
  roomCRSNumber: '',
  rateplanId: [],
  channelsId: [],
  crsStatus: [],
  pmsStatus: [],
  systemAllocations: false,
  providersCode: []
}

export const URL_FILTERS_DEFAULT_VALUE: URlFiltersData = {
  tenantsCode: [],
  propertyCode: [],
  roomtypeId: [],
  rateplanId: [],
  channelsId: [],
  pmsStatus: [],
  crsStatus: [],
  currency: undefined,
  reserveStartDate: '',
  startDate: '',
  departureEndDate: '',
  departureStartDate: '',
  roomstayInclusionDate: '',
  roomCRSNumber: '',
  pmsNumber: '',
  sourceReservationNumber: '',
  guestName: '',
  masterCRSNumber: '',
  reserveEndDate: '',
  endDate: '',
  systemAllocations: false,
  providersCode: []
}
